export default __webpack_public_path__ + "static/media/loading-loading-screen.72f68e1f.gif";